import { Component, HostBinding, Input, OnChanges } from '@angular/core';

import { FixtureViewType } from '@cds/betting-offer';
import {
    EventModel,
    EventScoreboard,
    IcehockeyPeriodGameScore,
    PeriodGameLiveScoreboardViewModel,
    PeriodGameScore,
    getIcehockeyPenalties,
    getOvertime,
    showPenalties,
} from '@frontend/sports/betting-offer/feature/model';
import { SitecoreEventDetailsConfig } from '@frontend/sports/common/client-config-data-access';
import { AmericanFootballQuarters, BasketballQuarters, IceHockeyPeriods, SportConstant } from '@frontend/sports/common/core/data-access/constants';

@Component({
    selector: 'ms-period-game-scoreboard-live',
    templateUrl: 'period-game-scoreboard-live.component.html',
    standalone: false,
})
export class PeriodGameScoreboardLiveComponent implements OnChanges {
    @HostBinding('class') className = 'period-game-live';
    @Input() scoreboard: EventScoreboard;
    @Input() event: EventModel;
    @Input() isNewEDPScoreboard = false;

    isIceHockeyPowerPlayTurn?: number;
    icons = {
        [SportConstant.Icehockey]: 'sports-sb-power-play',
        [SportConstant.AmericanFootball]: 'sports-sb-football',
    };

    overtimePeriods = {
        [SportConstant.Basketball]: BasketballQuarters.Overtime,
        [SportConstant.AmericanFootball]: AmericanFootballQuarters.Overtime,
        [SportConstant.Icehockey]: IceHockeyPeriods.Overtime,
    };

    isIcehockey = false;

    vm: PeriodGameLiveScoreboardViewModel = {
        showPenalties: false,
        penalties: [],
        score: new PeriodGameScore(),
        periodScore: [],
        isSuspended: false,
    };

    constructor(public sitecoreEventDetails: SitecoreEventDetailsConfig) {}

    ngOnChanges(): void {
        const score = this.event.scoreboard.getScore<PeriodGameScore>()!;
        this.isIcehockey = this.event.sport.id === SportConstant.Icehockey;
        const icehockeyScore = this.isIcehockey && this.event.scoreboard.getScore<IcehockeyPeriodGameScore>()!;
        const visibleCount = this.event.viewType === FixtureViewType.American ? 3 : 5;

        this.vm = {
            score,
            periodScore: score ? [score.participant1, score.participant2] : [],
            showPenalties: icehockeyScore && showPenalties(icehockeyScore),
            penalties: getIcehockeyPenalties(this.event, visibleCount),
            isSuspended: this.event.scoreboard.period && this.event.scoreboard.period.id === 256,
            showOvertime: getOvertime(this.event),
            isOvertimeActive: this.isOvertimeActive(),
            icon: this.icons[this.event.sport.id as keyof typeof this.icons],
        };
        const icehockeyMessage = this.scoreboard.messages?.filter((message) => message.type === 251 || message.type === 250);
        this.isIceHockeyPowerPlayTurn = !!icehockeyMessage && icehockeyMessage[0].type === 251 ? icehockeyMessage[0].teamType : undefined;
        this.vm.icon = !this.isIcehockey ? this.vm.icon : this.isIceHockeyPowerPlayTurn !== undefined && this.isIcehockey ? this.vm.icon : '';
    }

    private isOvertimeActive(): boolean {
        const periodId = this.event.scoreboard.period?.id;
        if (!periodId) {
            return false;
        }

        return this.overtimePeriods[this.event.sport.id as keyof typeof this.overtimePeriods] === periodId;
    }

    inVisibility(i: number): boolean {
        return this.isIceHockeyPowerPlayTurn === undefined || (this.isIcehockey ? this.isIceHockeyPowerPlayTurn === i : this.vm.score.turn === i + 1);
    }
}
